<template>
  <div class="header">
    <div
      id="topHeader"
      class="top-header"
      :class="{
        scrolled:
          isScrolled ||
          showAccountSelecter ||
          needBlackBg ||
          scrolledOnHomePortrait
      }"
    >
      <div class="switch-version-wrap" v-if="headerShowSwitchVersion">
        <div class="switch-version" @click="switchVersion">
          <em class="switch-icon"></em>
          {{ letter.v3SwitchOldVersion }}
        </div>
      </div>
      <div class="game-info" @click="backToHome">
        <img
          class="game-logo"
          v-if="logo"
          :src="logo"
          alt="game-logo"
          :class="{ large: isJpPlatform }"
        />
        <div class="header-safe">
          <em v-if="isGS" class="header-gs-icon"></em>
          <Icon v-else class="header-safe-icon" name="safe" />
          <p class="header-safe-tip">
            {{ letter.officialStore }} <br />
            {{ letter.headerSafeTip }}
          </p>
        </div>
      </div>
      <div class="right-info" :class="{ webviewRight: isInWebview }">
        <div class="header-pwa-install" v-if="isShowPwa">
          <pwa-install-top :location="3"></pwa-install-top>
        </div>
        <transition name="fade">
          <div
            v-if="isLogin && isShowCouponBtn"
            class="header-coupon-btn"
            :class="{ 'no-faq-btn': noFaqBtn }"
            @click="handleCouponButtonClick"
          >
            <div class="header-coupon-btn-ico" :style="couponIconStyle"></div>
            <em class="red-dot" v-if="showRedDot"></em>
          </div>
        </transition>
        <div class="lang-switch j-select-lang">
          <div class="lang-switch-pc flex-center" @click="toggleLangSelecter">
            <Icon class="lang-switch-ico" name="global" />
            <span class="lang-switch-text">{{ langList[lang] }}</span>
            <Icon
              class="lang-switch-right"
              :class="{ active: showLangSelecter }"
              name="down"
            />
          </div>
          <Icon
            class="lang-switch-m lang-switch-ico"
            name="global"
            @click="toggleLangSelecter"
          />
          <lang-selecter
            v-if="showLangSelecter"
            @closeSelecter="showLangSelecter = false"
            :langList="langList"
            :curLang="lang"
            :languages="letter"
            @selectLang="selectLang"
            @hideLangSelecter="showLangSelecter = false"
            style="z-index: 1002"
          ></lang-selecter>
        </div>
        <template v-if="showLogin">
          <div
            v-if="isLogin"
            @click.stop="handleShowAccountSelector"
            class="user-center-ico-wrap"
          >
            <Icon class="user-center-ico" name="me" />
            <em class="red-dot" v-if="showRedDot">+1</em>
          </div>
          <a
            v-else
            href="javascript:;"
            class="j-login-btn login-btn"
            @click="handleShowLoginPopup"
            >{{ letter.login }}</a
          >
        </template>
      </div>

      <transition name="slide-down">
        <account-selecter
          v-show="showAccountSelecter"
          @hideAccountSelecter="hideAccountSelecterHandle"
        ></account-selecter>
      </transition>
    </div>
  </div>
</template>

<script>
import PwaInstallTop from '@components/officialTopupNew/pwa/PwaInstallTop.vue';
import LangSelecter from '@components/officialTopupNew/LangSelecter.vue';
import AccountSelecter from '@components/officialTopupNew/AccountSelecter.vue';
import { mapGetters, mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { isSafari } from '@utiles/officialStore/device';
import { LANGUAGE_LOCALSTORGE_NAME } from '@store/languages';
import { SET_PWA_STATUS } from '@store/officialTopupNew/activity';
import { SET_ACCOUNT_SELECTER_STATUS } from '@store/officialTopupNew/login';
import {
  SWITCH_LANGUAGE,
  GET_PRODUCT_LIST,
  UPDATE_PRODUCT_LIST,
  UPDATE_PRODUCT_TYPES
} from '@store/officialTopupNew';
import { CLEAR_CART } from '@store/officialTopupNew/cart';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
import {
  locationType,
  clickButton,
  showPopup
} from '@plugins/biPoint/_configWebstoreV35';
import login from '@mixins/officialTopupNew/login';
import switchVersion from '@mixins/officialTopupNew/switchVersion';
import account from '@mixins/officialTopupNew/account';
import coupon from '@mixins/officialTopupNew/coupon';
import { b64DecodeUnicode } from '@utiles/officialStore';
export default {
  props: {
    showLogin: {
      type: Boolean,
      default: true
    },
    showCouponBtn: {
      type: Boolean,
      default: false
    }
  },
  mixins: [login, switchVersion, account, coupon],
  data() {
    return {
      showLangSelecter: false,
      isSafari: isSafari(),
      isHideAdd:
        globalConfig.getHrefParam('cid') === 'shortcut' ||
        globalConfig.getHrefParam('scid').includes('shortcut'),
      isScrolled: false,
      intersectionObserver: null,
      sentinelElement: null,
      couponBtnObserver: null,
      intersectionSetupTimer: null,
      intersectionRebuildTimer: null
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      langList: state => state.langList,
      gameId: state => state.gameId,
      picList: state => state.page.picList,
      showPwaInstall: state => state.activity.showPwaInstall,
      showAccountSelecter: state => state.login.showAccountSelecter,
      isInWebview: state => state.isInWebview,
      faqLangJson: state => state.page.faqLangJson,
      isInstall: state => state.page.isInstall,
      openPwa: state => state.page.openPwa,
      isLandscape: state => state.page.isLandscape
    }),
    ...mapGetters(['isJpPlatform']),
    noFaqBtn() {
      return !(this.faqLangJson?.[this.lang]?.content || '');
    },
    logo() {
      return this.picList?.icon;
    },
    pwaShowPwaInstall() {
      return (
        this.openPwa &&
        !this.isHideAdd && // pwa进入不展示
        (this.isSafari || !this.isInstall?.value) && // 已安装不展示，safari展示
        !this.isJpPlatform // 日本平台不展示
      );
    },
    isShowPwa() {
      let show = true;
      if (this.gameId == 191 && !this.isLandscape) {
        show = false;
      }
      return (
        show && this.showPwaInstall && this.pwaShowPwaInstall && this.isLogin
      );
    },
    needBlackBg() {
      return this.$route.path !== '/';
    },
    scrolledOnHomePortrait() {
      return this.$route.path === '/' && !this.isLandscape;
    },
    isGS() {
      let gs = false;
      const srtl = globalConfig.getHrefParam('srtl');
      const storeUrlParams = globalConfig.getHrefParam('store_url_params');
      const isResultPage =
        storeUrlParams && window.location.hash.includes('#/result');
      if (srtl) {
        gs = this.checkIsGS(srtl);
      } else if (isResultPage) {
        try {
          let store_url_params = decodeURIComponent(
            storeUrlParams.replace('#/result', '')
          );
          let storeParams = b64DecodeUnicode(store_url_params);
          let postOrderParams = {};
          const parsed = JSON.parse(storeParams);
          if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            postOrderParams = parsed;
            if (postOrderParams?.srtl) {
              gs = this.checkIsGS(postOrderParams?.srtl);
            }
          }
        } catch (error) {
          console.error(error);
          gs = false;
        }
      }
      return gs;
    },
    isShowCouponBtn() {
      return this.showCouponBtn && ![386, 456].includes(+this.gameId);
    }
  },
  mounted() {
    this.intersectionSetupTimer = setTimeout(() => {
      this.intersectionSetupTimer = null;
      this.setupIntersectionObserver();
    }, 2000);
  },
  beforeDestroy() {
    if (this.intersectionSetupTimer) {
      clearTimeout(this.intersectionSetupTimer);
      this.intersectionSetupTimer = null;
    }
    if (this.intersectionRebuildTimer) {
      clearTimeout(this.intersectionRebuildTimer);
      this.intersectionRebuildTimer = null;
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
    if (this.couponBtnObserver) {
      this.couponBtnObserver.disconnect();
      this.couponBtnObserver = null;
    }
  },
  methods: {
    checkIsGS(srtl) {
      let isGs = false;
      if (srtl) {
        const srtlArr = srtl?.split?.('.') || [];
        if (srtlArr?.length > 2 && srtlArr[0] === '3258' && srtlArr[2]) {
          isGs = true;
        }
      }
      return isGs;
    },
    setupIntersectionObserver() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      this.intersectionObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            this.isScrolled = !entry.isIntersecting;
          });
        },
        {
          root: null,
          rootMargin: '-130px',
          threshold: 0
        }
      );
      const ele = document.querySelector('.banner');
      ele && this.intersectionObserver.observe(ele);
    },

    backToHome() {
      if (this.$route.name === 'home') return;
      this.$router.push({
        name: 'home'
      });
    },
    selectLang(val) {
      this.showLangSelecter = false;
      globalConfig.setLclStorageItem(LANGUAGE_LOCALSTORGE_NAME, val);
      this.$store.dispatch(SWITCH_LANGUAGE, val);
      if (this.$store.state.serverId && this.$store.state.roleId) {
        this.$store.dispatch(GET_PRODUCT_LIST);
        this.$store.commit(UPDATE_PRODUCT_LIST, []);
        this.$store.commit(UPDATE_PRODUCT_TYPES, []);
      }
      this.$store.commit(CLEAR_CART);
      updateCommonParamsInfo({
        language: val
      });
      clickButton({
        btnName: 'select_language',
        locationKey: this.$route.meta.pageName
      });

      // 语言切换后重置滚动状态并重新初始化 IntersectionObserver
      this.isScrolled = false;
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }
      if (this.intersectionRebuildTimer) {
        clearTimeout(this.intersectionRebuildTimer);
      }
      this.$nextTick(() => {
        this.intersectionRebuildTimer = setTimeout(() => {
          this.intersectionRebuildTimer = null;
          this.setupIntersectionObserver();
        }, 300);
      });
    },
    toggleLangSelecter() {
      clickButton({
        btnName: 'select_language_btn',
        locationKey: this.$route.meta.pageName
      });
      this.showLangSelecter = !this.showLangSelecter;
    },
    handleShowLoginPopup() {
      clickButton({
        btnName: 'go_login',
        locationKey: locationType.accountInfo
      });
      this.showLoginPopup();
    },
    handleHeaderPwaInstall(state) {
      this.$store.commit(SET_PWA_STATUS, state);
    },
    handleShowAccountSelector() {
      this.$store.commit(
        SET_ACCOUNT_SELECTER_STATUS,
        !this.showAccountSelecter
      );
      clickButton({
        btnName: 'account_info',
        locationKey: this.$route.meta.pageName
      });
      if (this.showAccountSelecter) {
        showPopup(locationType.accountInfoPopup);
      }
    },
    hideAccountSelecterHandle() {
      this.$store.commit(SET_ACCOUNT_SELECTER_STATUS, false);
    }
  },

  components: {
    PwaInstallTop,
    LangSelecter,
    AccountSelecter
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
@import '@assets/scss/officialTopupNew/animate.scss';
.header {
  z-index: 31;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.top-header {
  display: flex;
  justify-content: space-between;
  height: $headerHeight;
  width: 100%;
  font-size: 20px;
  background-position: center center;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: relative;
  transition: background-color 0.3s ease;

  &.scrolled {
    background-color: #000000;
  }

  .game-info {
    display: flex;
    align-items: center;
    margin-left: 42px;
    .game-logo {
      width: 68px;
      border-radius: 9px;
      cursor: pointer;
      &.large {
        width: 120px;
      }
    }
  }
  .right-info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    margin-right: 42px;
    gap: 20px;
    &.webviewRight {
      margin-right: 82px;
    }

    .login-btn {
      margin-left: 20px;
      background-color: #ffffff;
      color: #000000;
      font-size: 24px;
      padding: 10px 40px;
      border-radius: 40px;
      white-space: nowrap;
    }

    .lang-switch {
      position: relative;
      color: #ffffff;

      &-ico {
        display: inline-block;
        margin-right: 10px;
        width: 44px;
        height: 44px;
      }
      &-right {
        width: 32px;
        height: 32px;

        &.active {
          transform: rotate(180deg);
        }
      }

      .lang-switch-pc {
        display: none;
      }
      .lang-switch-m {
        display: inline-block;
        font-size: 44px;
      }
    }
    .user-center-ico-wrap {
      position: relative;
    }
    .user-center-ico {
      width: 44px;
      height: 44px;
      color: #ffffff;
      cursor: pointer;
    }

    .header-coupon-btn {
      display: none;
      box-sizing: border-box;
      z-index: 20;
      position: fixed;
      right: 10px;
      bottom: 440px;
      align-items: center;
      justify-content: center;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      cursor: pointer;

      &.no-faq-btn {
        bottom: 340px;
      }

      &-ico {
        width: 66px;
        height: 66px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        animation: shake 3s ease infinite;
      }

      .red-dot {
        position: absolute;
        top: -7px;
        right: -7px;
        width: 16px;
        height: 16px;
        background-color: #ff2800;
        border-radius: 50%;
      }
    }
  }
  .header-pwa-install {
    display: none;
  }
  .header-safe {
    margin-left: 20px;
    margin-right: 20px;
    padding: 12px 17px 15px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 16px;
    justify-self: center;
    align-items: center;
    display: flex;

    .header-gs-icon {
      width: 40px;
      height: 46px;
      background: url($commonImg + 'gs-icon.png') no-repeat center/contain;
    }
    .header-safe-icon {
      width: 40px;
      height: 46px;
      color: $themeColor;
    }
    .header-safe-tip {
      margin-left: 10px;
      font-size: 16px;
      color: #ffffff;
      line-height: 1.5;
    }
  }
  .btn-wrap {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    background: #fff;
    border-radius: 30px;
    padding: 0 20px;
    height: 45px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .red-dot {
    position: absolute;
    right: -7px;
    top: -7px;
    width: 16px;
    height: 16px;
    background-color: #ff2800;
    border-radius: 50%;
    font-size: 12px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .switch-version-wrap {
    position: absolute;
    top: 120px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 20px;
    width: 100%;
    height: 173px;
    top: 0;
    z-index: -1;
    .switch-version {
      position: absolute;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 186px;
      height: 53px;
      font-size: 18px;
      color: #ffffff;
      cursor: pointer;
      width: 100%;
      .switch-icon {
        display: block;
        width: 29px;
        height: 29px;
        margin-right: 5px;
        background: url($commonImg + 'switch-version.png') no-repeat;
        background-size: cover;
      }
    }
  }
}

#ssr-page.landscape {
  .top-header {
    .game-info {
      .game-logo {
        width: 68px;
        &.large {
          width: 120px;
        }
      }
    }
    .right-info {
      .lang-switch {
        &-ico {
          width: 32px;
          height: 32px;
        }
        &-right {
          width: 32px;
          height: 32px;
        }
        .lang-switch-pc {
          display: flex;
          cursor: pointer;

          .lang-switch-text {
            ::v-deep .select {
              padding: 0;
            }
          }
        }
        .lang-switch-m {
          display: none;
        }
      }
      .user-center-ico {
        width: 32px;
        height: 32px;
      }

      .header-coupon-btn {
        display: flex;
        z-index: 1;
        position: relative;
        right: unset;
        bottom: unset;
        width: unset;
        height: unset;
        margin-right: 10px;
        background-color: unset;

        &-ico {
          width: 58px;
          height: 63px;
        }
      }

      .header-pwa-install {
        display: inline-block;
      }
    }
    .switch-version-wrap {
      display: none;
    }
  }
}
</style>
